import React from 'react';
import { string, bool } from 'prop-types';

const CountryFlag = props => {
  const { className, show, countryCode, altText } = props;
  if (!show) {
    return null;
  }
  return (
    <img
      className={className}
      title={altText}
      alt={altText}
      src={`https://cdn.pji.nu/g/rfe/icons/flags/16x11/${countryCode}.gif`}
    />
  );
};

CountryFlag.propTypes = {
  show: bool,
  countryCode: string.isRequired,
  altText: string,
  className: string,
};

CountryFlag.defaultProps = {
  altText: '',
  show: true,
  className: '',
};

export default CountryFlag;
